export default __webpack_public_path__ + "static/media/arrowRight-pri.fd337496.svg";